// Mock data for VERSO SOFTECH landing page

export const navigationLinks = [
  { name: 'PRODUCTOS', href: '#productos' },
  { name: 'NOSOTROS', href: '#nosotros' },
  { name: 'FAQ', href: '#faq' }
];

export const features = [
  {
    id: 1,
    title: 'Control de Inventario',
    description: 'Gestiona tu inventario de repuestos y servicios en tiempo real con alertas automáticas de stock bajo.',
    icon: 'package'
  },
  {
    id: 2,
    title: 'Plataforma de Proveedores',
    description: 'Conecta directamente con proveedores certificados y gestiona órdenes de compra de manera eficiente.',
    icon: 'users'
  },
  {
    id: 3,
    title: 'Historial en la Nube',
    description: 'Accede al historial completo de vehículos y servicios desde cualquier dispositivo, en cualquier momento.',
    icon: 'cloud'
  },
  {
    id: 4,
    title: 'Gestión Integral',
    description: 'Administra citas, clientes, facturación y reportes desde una sola plataforma intuitiva y potente.',
    icon: 'clipboard'
  }
];

export const workshopFeatures = [
  {
    id: 1,
    title: 'Diagnóstico Digital',
    description: 'Sistema avanzado de diagnóstico vehicular con conexión directa a bases de datos OEM.',
    icon: 'activity'
  },
  {
    id: 2,
    title: 'Gestión de Citas',
    description: 'Calendario inteligente que optimiza tu agenda y reduce tiempos muertos.',
    icon: 'calendar'
  },
  {
    id: 3,
    title: 'CRM Automotriz',
    description: 'Mantén relaciones duraderas con tus clientes mediante seguimiento automatizado.',
    icon: 'heart'
  }
];

export const supplierFeatures = [
  {
    id: 1,
    title: 'Catálogo Digital',
    description: 'Publica y actualiza tu catálogo de repuestos con búsqueda inteligente por VIN.',
    icon: 'book-open'
  },
  {
    id: 2,
    title: 'Órdenes Automatizadas',
    description: 'Recibe y procesa pedidos automáticamente con confirmación instantánea.',
    icon: 'shopping-cart'
  },
  {
    id: 3,
    title: 'Analytics Avanzado',
    description: 'Analiza tendencias de ventas y optimiza tu inventario basado en datos reales.',
    icon: 'trending-up'
  }
];

export const stats = [
  { value: '400k+', label: 'Descargas' },
  { value: '15k+', label: 'Talleres Activos' },
  { value: '2.5M+', label: 'Reportes Generados' },
  { value: '98%', label: 'Satisfacción' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Carlos Rodríguez',
    role: 'Propietario - Taller MecaPro',
    comment: 'VERSO transformó completamente la gestión de mi taller. Ahora puedo atender más clientes con la misma calidad.',
    rating: 5
  },
  {
    id: 2,
    name: 'María González',
    role: 'Gerente - AutoRepuestos del Sur',
    comment: 'La plataforma de proveedores nos conectó con cientos de talleres nuevos. Nuestras ventas aumentaron un 45%.',
    rating: 5
  },
  {
    id: 3,
    name: 'Juan Pérez',
    role: 'Mecánico Jefe - Servicio Express',
    comment: 'El historial vehicular en la nube nos ayuda a dar un servicio más profesional y confiable a nuestros clientes.',
    rating: 5
  }
];

export const faqData = [
  {
    id: 1,
    question: '¿Qué incluye el reporte de historial vehicular?',
    answer: 'Nuestro reporte incluye historial de mantenimiento, accidentes registrados, cambios de propietario, kilometraje verificado, y alertas de posibles fraudes o problemas mecánicos.'
  },
  {
    id: 2,
    question: '¿Cómo funciona la app para talleres?',
    answer: 'La app VERSO Talleres te permite gestionar citas, clientes, inventario, facturación y generar reportes de diagnóstico. Todo sincronizado en la nube para acceso desde cualquier dispositivo.'
  },
  {
    id: 3,
    question: '¿La plataforma de proveedores tiene costo?',
    answer: 'Ofrecemos planes flexibles según el tamaño de tu negocio. Contacta con nuestro equipo de ventas para conocer la mejor opción para ti.'
  },
  {
    id: 4,
    question: '¿Necesito internet para usar las aplicaciones?',
    answer: 'Las apps funcionan en modo offline para funciones básicas, pero requieren conexión para sincronización de datos y acceso a reportes en tiempo real.'
  }
];